import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=c1dd2f42&scoped=true"
import script from "./Support.vue?vue&type=script&lang=ts"
export * from "./Support.vue?vue&type=script&lang=ts"
import style0 from "./Support.vue?vue&type=style&index=0&id=c1dd2f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dd2f42",
  null
  
)

export default component.exports